export enum WebhookEventOrigin {
  ANTICIPATION = 'anticipation',
  SUBSCRIPTION = 'subscription',
  CARD = 'card',
  CHECKOUT = 'checkout',
  CUSTOMER = 'customer',
  CHARGE = 'charge',
  BANK_ACCOUNT = 'bank_account',
  DISCOUNT = 'discount',
  ADDRESS = 'address',
  INVOICE = 'invoice',
  SUBSCRIPTION_ITEM = 'subscription_item',
  ORDER_ITEM = 'order_item',
  PLAN_ITEM = 'plan_item',
  ORDER = 'order',
  PLAN = 'plan',
  RECIPIENT = 'recipient',
  TRANSFER = 'transfer',
  USAGE = 'usage',
  SELLER = 'seller'
}
